import type { EntityField } from '@ContractBuilder/contract-builder-header/constants';
import { isEqual } from 'lodash-es';
import { createWithEqualityFn } from 'zustand/traditional';

type UiState = {
  isBlockUsedInTemplatesModalOpen: boolean;
  isPDFPreviewOpen: boolean;
  reset: () => void;
  setBlockUsedInTemplatesModalVisibility: (visibility: boolean) => void;
  showHiddenFields: boolean;
  togglePDFPreview: () => void;
  toggleShowHiddenFields: () => void;
  activeEditingField: EntityField | undefined;
  setActiveEditingField: (field: EntityField | undefined) => void;
};

export const useUIStore = createWithEqualityFn<UiState>(
  (set) => ({
    isBlockUsedInTemplatesModalOpen: false,
    isPDFPreviewOpen: false,
    reset: () =>
      set({
        isBlockUsedInTemplatesModalOpen: false,
        showHiddenFields: false,
        activeEditingField: undefined,
        isPDFPreviewOpen: false,
      }),
    setBlockUsedInTemplatesModalVisibility: (value) => set({ isBlockUsedInTemplatesModalOpen: value }),
    showHiddenFields: false,
    togglePDFPreview: () =>
      set((state) => {
        const newValue = !state.isPDFPreviewOpen;
        return { isPDFPreviewOpen: newValue };
      }),
    toggleShowHiddenFields: () => set((state) => ({ showHiddenFields: !state.showHiddenFields })),
    activeEditingField: undefined,
    setActiveEditingField: (field: EntityField | undefined) => set({ activeEditingField: field }),
  }),
  isEqual,
);
